<template>

    <div class="layout__padding-clear layout__width-80">

        <div class="">
            <CustomerOrdersSearch v-bind:searchParams="searchParams" v-bind:orders="orders" v-bind:view="view" v-bind:loading="loading" v-bind:resultsCount="resultsCount"></CustomerOrdersSearch>
        </div>

        <div class="layout__width-100 layout__position-left">
            <el-table :data="orders" width="100%" class="layout__height-600px layout__scrolling__right layout__margin__bottom-30" v-loading="loading">
                <el-table-column prop="orderId" label="Order Id">
                </el-table-column>
                <el-table-column prop="jobName" label="Order Ref">
                </el-table-column>
                <el-table-column prop="status" label="Status">
                </el-table-column>
                <el-table-column prop="created" label="Created" :formatter="formatDateDDMMYYYYCreated">
                </el-table-column>
                <el-table-column prop="quantity" label="Qty">
                </el-table-column>
                <el-table-column prop="billGrossTotal" label="Cost (GBP)" :formatter="returnCurrency">
                </el-table-column>
            </el-table>
        </div>

        <div class="layout__padding-clear layout__width-60">
            <div class="layout__padding-20-0">
                <el-pagination class="layout__padding-clear"
                               @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :current-page="this.searchParams.currentPage"
                               :page-sizes="[20, 40, 60, 80, 100]"
                               :page-size="this.searchParams.pagination"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="this.resultsCount">
                </el-pagination>
            </div>
        </div>
    </div>

</template>

<script>

    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import CustomerOrdersSearch from '../../components/search/CustomerOrdersSearch';
    import Pagination from "../../components/Pagination";
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {pagination} from '@/mixins/Pagination.js';

    export default {
        name: "bespokeOrders",
        mixins: [axios, dataFormatter, pagination],
        components: {
            Pagination,
            CustomerOrdersSearch
        },
        data() {
            return {
                resultsCount: '',
                orders: [],
                loading: false,
                searchParams: {

                },
                view: 'Bespoke',
            }
        },
        methods: {
            resultsPerPage() {
                document.getElementById('getCustomerOrdersPagination').click()
            },
        }
    };
</script>